import { PropsWithChildren, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { SynotaSpinner } from "@synota-io/synota-shared-ui";
import { Box, Stack } from "@mui/material";
import { useAuth } from "../../api/auth/useAuth";

export const ProtectedPage = ({
  children,
  adminOnly,
}: PropsWithChildren<{ adminOnly?: boolean }>) => {
  const { isLogged, isLoading, isAdmin } = useAuth();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(!isLoading);
  }, [isLoading]);

  if (!hydrated) {
    return (
      <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center">
        <Stack alignItems="center" gap={8} mb={8}>
          <SynotaSpinner />
        </Stack>
      </Box>
    );
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (isLogged) {
    return <>{children}</>;
  }

  return <Navigate to="/account/login" replace />;
};
